import * as React from 'react'
import { Button } from '@/components/ui/button'

import type { AppointmentRecord } from '@/features/appointments/types'
import { AppointmentStatusBadge } from './AppointmentStatusBadge'
import { formatAppointmentTime } from './AppointmentsColumns'

/** Compact card for one appointment in a calendar day column. */
export function AppointmentsCalendarCard({
  appointment,
  onSelect,
}: {
  onSelect?: (appointment: AppointmentRecord) => void
  appointment: AppointmentRecord
}) {
  const time = formatAppointmentTime(appointment.start_time)
  return (
    <div role="listitem">
      <Button
        variant="outline"
        id={appointment.id}
        type="button"
        onClick={() => onSelect?.(appointment)}
        className="block h-auto w-full whitespace-normal cursor-pointer rounded-lg border bg-card p-2 text-left shadow-xs hover:bg-muted/50">
        <div className="flex items-center justify-between gap-1">
          <span className="text-xs font-medium tabular-nums whitespace-nowrap">
            {time ?? <span className="text-muted-foreground">All day</span>}
          </span>
          <AppointmentStatusBadge status={appointment.status} />
        </div>
        <div className="mt-1 truncate text-sm font-medium">
          {appointment.patient_name ?? (
            <span className="text-muted-foreground">Unknown patient</span>
          )}
        </div>
        <div className="truncate text-xs text-muted-foreground">
          {appointment.appointment_type ?? 'Appointment'}
        </div>
        {appointment.provider_name ? (
          <div className="truncate text-xs text-muted-foreground">
            {appointment.provider_name}
          </div>
        ) : null}
        {appointment.location ? (
          <div
            className="truncate text-xs text-muted-foreground"
            title={appointment.location}>
            {appointment.location}
          </div>
        ) : null}
      </Button>
    </div>
  )
}
